import React from "react";
import CommonModal from "./CommonModal";
import { primaryColor, secondaryColor } from "../../../utils/comon";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Confirmation",
  description = "Are you sure you want to delete this item? This action cannot be undone.",
  confirmBtnText = "Delete",
  cancelBtnText = "Cancel",
  isLoading = false,
}) => {
  return (
    <CommonModal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="flex flex-col items-center text-center py-4">

        <p className="text-[#64748B] text-sm leading-relaxed mb-8 max-w-[280px]">
          {description}
        </p>

        <div className="flex gap-4 w-full">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="flex-1 bg-[#F1F5F9] hover:bg-[#E2E8F0] text-[#0F172A] font-medium py-2 rounded-lg transition-colors duration-200 disabled:opacity-50"
          >
            {cancelBtnText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 font-medium py-2 rounded-lg transition-colors duration-200 disabled:opacity-50"
            style={{ backgroundColor: primaryColor(), color: secondaryColor() }}
          >
            {isLoading ? <FontAwesomeIcon icon={faSpinner} className="animate-spin" /> : confirmBtnText}
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

export default DeleteModal;
